import { SessionRepository } from '../../../repositories/sessionRepository';
import UserRepository from '../../../repositories/userRepository';

export const reactivateLoader = async () => {
	try {
		const user = await UserRepository.getUser();
		if (user) {
			try {
				return SessionRepository.logout();
			} catch {
				return true;
			}
		}

		return true;
	} catch {
		return true;
	}
};
